import { Column } from "@components/Layout";
import { Motion } from "@motionone/solid";
import { FaSolidXmark } from "solid-icons/fa";
import { styled } from "solid-styled-components";

export const NavbarWrapper = styled(Motion.nav)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${({ theme }) => theme?.colors.foreground};
  height: 100%;
  width: 400px;
  padding: 20px 20px 0;
  overflow: auto;
  @media only screen and (max-width: 1680px) {
    width: 320px;
  }
  @media only screen and (max-width: 1200px) {
    position: fixed;
    right: 100vw;
    width: 100dvw;
    z-index: 10;
    padding: 60px 20px 0;
  }
`;

export const NavItemsColumn = styled(Column)`
  gap: 12px;
`;

export const CloseButton = styled(FaSolidXmark)`
  position: absolute;
  top: 10px;
  right: 10px;
  display: none;
  @media only screen and (max-width: 1680px) {
    display: block;
    cursor: pointer;
  }
`;
